/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Select from "react-select";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Accordion from '../../accordion'


import  IntlTelInput  from "react-intl-tel-input";
import { libphonenumber } from "react-intl-tel-input/dist/libphonenumber.js";
import PlacesAutocomplete, {
	geocodeByAddress,
	getLatLng,
} from "react-places-autocomplete";

// ../../../../images/candidate/upload.png
//  download fill

import Upload from "../../../../images/candidate/download.svg";
import { UncontrolledTooltip, Input } from "reactstrap";

import pdf_icon from "../../images/document.svg";
import { IsArray, createFormData, isValidDate as isvalidDate  } from "../../../common/utils";
import moment from "moment";
import upload_icon from "../../../../images/candidate/upload.svg";
import { toast } from "react-toastify";
import request from "../../../../api/api";




export const RequiredTag = ({ required = false , display = 'none'}) =>
  required ? <span style={{ color: "red" , display}}>*</span> : <></>;


export const SelectInput = React.forwardRef( ({label = '' , options = [] ,error = '' , required=false, lowercase , trim=false , ...restprops } , ref) => {
    lowercase = [true,false].includes(lowercase) ? lowercase : true;
    trim = [true,false].includes(trim) ? trim : true;

    return <div className="position-relative col-12 col-md-4">
        <div className="form-group">
            <Input  type="select"  {...restprops} innerRef={ref} className={`${error ? "is-invalid" :''}`}>
            <option value="">Please Select</option>
              {
                  Array.isArray(options) && options.length > 0 
                  ? options.map((item = "" , i)=>{
                    let value = item || '';
                        value = lowercase ?  (""+item).toLowerCase().replace('.','') : value;
                        value = trim ? value.replace(/ /g ,'') : value;

                    return <option key={i} value={value}>{item}</option>
                  })
                  : <></>
              }
            </Input>
            <label>{label} <RequiredTag required={required} /> </label>
        </div>
    </div>
})



export const TextInput = React.forwardRef(({ label = '', placeholder = '', error = '',parentClassName = '', required=false,...restprops }, ref) => {
    return (
        <>
            <div className={`position-relative col-12 col-md-4 ${parentClassName}`} >
                <div className="form-group">
                    <Input
                        type="text"
                        placeholder={placeholder}
                        {...restprops}
                        className={`${(restprops && restprops.className) || '' } ${error ? "is-invalid" : ''}`}
                        innerRef={ref}
                    />
                    <label>{label} <RequiredTag required={required} /></label>
                    {
                    error ? <div class="invalid-feedback">{error}<i class="fa fa-exclamation-circle" aria-hidden="true"></i> </div> : <></>
                    }

                </div>
            </div>
        </>
    )
})

export const NumberInput = React.forwardRef(({ label = '', placeholder = '', error = '', parentClassName = '',required=false, ...restprops }, ref) => {
    return (
        <>
            <div className={`position-relative col-12 col-md-4 ${parentClassName}`}>
                <div className="form-group">
                    <Input
                        type="number"
                        placeholder={placeholder}
                        {...restprops}
                        className={`${(restprops && restprops.className) || '' } ${error ? "is-invalid" : ''}`}
                        innerRef={ref}
                    />
                    <label>{label} <RequiredTag required={required} /> </label>
                    {
                    error ? <div class="invalid-feedback">{error}<i class="fa fa-exclamation-circle" aria-hidden="true"></i> </div> : <></>
                    }
                </div>
            </div>
        </>
    )
})


export const YESORNO = ({label = "" , name ="" ,register = ()=>{}, parentClassName="",required=false , ...restprops }) => {
    return <div className={`position-relative col-12 col-md-4 ${parentClassName}`}>
        <div className="form-check-box">
            <p>{label} <RequiredTag required={true}/> </p>
            <ul>
                <li>
                    <label>
                    <input {...register(name)} value="yes" type="radio" />
                    Yes
                    </label>
                </li>
                <li>
                    <label>
                    <input {...register(name)} value='no' type="radio" />
                    No
                    </label>
                </li>
            </ul>
        </div>
    </div>
}


export const MultipleChoice = ({ label = "", name = "", options = [] , register = () => { } ,required=false, lowercase = true , toggleName = {}, ...restprops }) => {
    return <div className="position-relative col-12 col-md-4">
        <div className="form-check-box yes-no">
            <p>{label}</p>
            <ul>
                {
                    IsArray(options)
                        ? options.map((item = '', i) => {
                            let value = lowercase ? item.toLowerCase() : item
                            return <li key={i}>
                                <label>
                                <input {...register(name)} value={value} type="radio" />{ item }
                                </label>
                            </li>
                        })
                        : <></>
                }

            </ul>
        </div>
    </div>
}


export const TextAreaInput = React.forwardRef(({ label = '' ,placeholder = '' , parentClassName="",required=false,error='', ...restprops  },ref) => {
    return <div className={`position-relative col-12 col-md-8 ${parentClassName}`} >
        <div className="form-group about_me">
            <textarea
                style={error ? {borderColor:"#dc3545"}:{}}
                placeholder={placeholder}
                {...restprops}
                className={`form-control ${(restprops && restprops.className) || '' } ${error ? "is-invalid" : ''}`}
                ref={ref}
            ></textarea>
            <label>{label } <RequiredTag required={required} /> </label>
        </div>
    </div>
});


export const DateInput = ({ handleOnDateChange = () => { }, value = '' ,label ='' , name = '' , isValidDate = (c)=>c ,error='', parentClassName='',required=false ,...restprops }) => {
    return <div className={`position-relative col-12 col-md-4 ${parentClassName}`}>
        <div className="form-group">
            <Datetime
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                closeOnSelect={true}
                isValidDate={isValidDate}
                inputProps={({className})=>({
                    className:error ? "is-invalid" :className,
                    // placeholder: "Select Date",
                    // readOnly: true,
                    required,
                    name,
                    ...restprops,
                    
                })}
                onChange={(e)=>handleOnDateChange(e ,name)}
                value={isvalidDate(value) ? moment(value).format("DD-MM-YYYY") : ""}
            />

            <label className={`${value ? 'data-label' : ''}`}>{label} <RequiredTag required={required}  display="inline" /></label>
        </div>
    </div>
};

export const MultipleCheckBox = ({ label = '', options = [], register = () => { },toggleName = {} ,required=false}) => {
    return <div className="position-relative col-12 col-md-12">
        <div className="form-check-box full_check_box">
            <p>{label}</p>
            <ul>
                {
                    Array.isArray(options) && options.length
                        ? options.map((item, i) =>{
                            let name = toggleName[item] || item;
                            return (<li key={item}> <label> <input type="checkbox" {...register(name)} /> {item} </label></li>)
                        })
                        : null
                }
            </ul>
        </div>
    </div>
}



export const MobileNumberWithCode = React.forwardRef(({ label = '',defaultCountry="",handleOnchange=()=>{} , handleSelectFlag = ()=>{} ,value="", error = '',parentClassName = '', required=false,...restprops },ref) => {
    return <div className={`position-relative col-12 col-md-4 ${parentClassName}`} >
        <div className="form-group">
            <IntlTelInput
                {...restprops}
                placeholder={label}
                style={{ width: "100%" }}
                defaultCountry={defaultCountry}
                utilsScript={libphonenumber}
                css={[ "intl-tel-input",`${error ? "is-invalid form-control" : 'form-control'}`]}
                onPhoneNumberChange={handleOnchange}
                onSelectFlag={handleSelectFlag}
                value={value}
                ref={ref}
            />
            <label className="focus-stage" >{label} <RequiredTag required={required} display="inline" /></label>
            {
                error ? <div class="invalid-feedback d-inline">{error}<i class="fa fa-exclamation-circle" aria-hidden="true"></i> </div> : <></>
            }

        </div>
    </div>

})



export const CheckBoxInput = React.forwardRef((props = {}, ref) => {
    return <span> <input type="checkbox" ref={ref} {...props} /> </span>
})





// Chennai City Centre, Doctor Radha Krishnan Salai, Loganathan Colony, Mylapore, Chennai, Tamil Nadu, India
// 
export const LocationSearchInput = React.forwardRef(({ onSelect=()=>{} , label = '',error = '', parentClassName = '',required=false, handleOnchange =()=>{} , value ="" },ref) => {


    const handleSelect = address => {
      geocodeByAddress(address)
        .then(results =>{
            const addressData = { addressline1:address, addressline2:"", city:"", state:"", country:"", zip:"" };
             if(IsArray(results[0].address_components)){
                results[0].address_components.forEach((item ={})=>{
                    if(item.types.includes("route")){
                        addressData.addressline2 = item.long_name || '';
                    }
                    if(item.types.includes("postal_town")){
                        addressData.city = item.long_name || '';
                    }
                    if(item.types.includes("administrative_area_level_1")){
                        addressData.state = item.long_name || '';
                    }
                    if(item.types.includes("country")){
                        addressData.country = item.long_name || '';
                    }
                    if(item.types.includes("postal_code")){
                        addressData.zip = item.long_name || '';
                    }
                })
             }
                onSelect(addressData , results);
                return addressData;
        })
        .catch(error => console.error('Error', error));
    };
    
    return (
        <div className={`position-relative col-12 col-md-4 ${parentClassName || ''}`} >
            <div className="form-group">
                <PlacesAutocomplete
                    onSelect={handleSelect}
                    value={value}
                    ref={ref}
                    onChange={handleOnchange}
                >
                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div>
                            <>
                                <Input
                                    type="text"
                                    placeholder={label}
                                    {...getInputProps({ className: `${error ? "is-invalid" : ''} form-control` })}
                                />
                                <label>{label}  <RequiredTag required={required} />  </label>
                                {
                                    error ? <div class="invalid-feedback">{error}<i class="fa fa-exclamation-circle" aria-hidden="true"></i> </div> : <></>
                                }

                            </>

                            <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map((suggestion, i) => {
                                    const className = suggestion.active
                                        ? 'suggestion-item--active'
                                        : 'suggestion-item';
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                        : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                    return (
                                        <div
                                            {...getSuggestionItemProps(suggestion, {
                                                className,
                                                style,
                                            })}
                                            key={i}
                                        >
                                            <span>{suggestion.description}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </PlacesAutocomplete>
            </div>
        </div>
    );

})


export const UploadInput = React.forwardRef(({ id='',label="", upload_isdisable=false, handleOnChangeFiles=()=>{}, handleOnFilesDelete=()=>{}, toggleImageViewer=()=>{} ,file_list=[]},ref) => {
    let tooltip_Id = `uploads-${id}`;
    return (
        <>
            <div className="position-relative col-12 col-md-3 file_join">
                <div className="form-group doc-list">
                    <div className="edit-upload-file">
                        <label>
                            <img src={upload_icon} style={{ cursor: 'pointer' }} alt="" id={tooltip_Id} />
                            <input ref={ref} className="d-none" type="file" accept="application/pdf,.pdf,image/*" onChange={handleOnChangeFiles} />
                            <span style={{display:"block"}}>{label}</span>
                        </label>
                    </div>
                </div>
                <UncontrolledTooltip placement="top" target={tooltip_Id}>{label}</UncontrolledTooltip>
            </div>

            <div className="position-relative col-12 col-md-12">
                <div className="form-group doc-list preview">
                    <ul>
                        {
                            IsArray(file_list)
                            ? file_list.map((url)=><FileViewDoc key={url} url={url} onClick={() => toggleImageViewer(url)} onDelete={() => handleOnFilesDelete(url)} />)
                            : null
                        }
                        
                    </ul>
                </div>
            </div>
        </>
    )
});

const FileViewDoc = ({ url = '' , onClick = ()=>{} , onDelete = ()=>{}}) => {
    let id = url.replace(/[\/.]/g ,"-")
  return (
    url
    ? <li>
        <span id={id}> <img src={pdf_icon} alt="doc Viewer" onClick={()=>onClick(url)} />     </span>
        <button type="button" onClick={onDelete}><i class="fa fa-trash-o" aria-hidden="true"></i> </button>
        <UncontrolledTooltip placement="bottom" target={id}>View Document</UncontrolledTooltip>
      </li>
    : null
  );
};



const addfileToServer = async (file = {}) =>{
    try {
    const res = await request({ url: "/candidate/form/addFilestoLocalDB", method: "POST", data:file,})
        return res.file_path ? res.file_path :''
    } catch (error) {
        return;
    }
}



export const AddtionalFormFields = ({ fields=[] , register=()=>{} , handleOnDateChange=()=>{} , watch=()=>{} , errors={} , toggleImageViewer=()=>{} , setValue=()=>{}, getValues=()=>{} }) =>{

    // ["pdf" , "png" ,"jpeg" ,"jpg"].includes(temp1.type))slice('dddddimage/png'.search("/"))
    const handleOnChangeFiles = async (e = {} ,name = '') =>{
        let files = (e && e.target && e.target.files) ? e.target.files : [];
            files = files.length ? files[0] : null;

        if(!files) return;
        if(!(files.size < 5242880)){
            return toast.error("Maximum upload size is 5MB");
        }
        if(!["pdf" , "png" ,"jpeg" ,"jpg"].includes(files.type.slice(files.type.search("/") + 1))){
            return toast.error("File Format not supported");
        }
            let data = createFormData({upload_doc : files})
            let url = await addfileToServer(data);
            if(url){
                setValue(name,[...getValues(name) , url])
                // toast.success("File Saved!")
            }


    }
    const handleOnFilesDelete = (path , name)=>{
        let url = getValues(name).filter(i => i !== path);
        url && setValue(name , url);
    }


    return fields.map((item ={}, index)=>{
            // item.value = item.value || '';
        let name = `addtionalFields.${index}.value`,
            field_name = item.field_name,
            field_required = item.field_required,
            error = (errors.addtionalFields && errors.addtionalFields[index] && errors.addtionalFields[index].value && errors.addtionalFields[index].value.message) || "";  
            // error = errors[name] && errors[name].message;  
        if(item.field_type === "Dropdown"){
            return  <SelectInput key={item.id} label={field_name} options={item.sub_fields} required={field_required} {...register(name ,{...(field_required) && {validate:(v)=>Boolean(v) ||"Required"} } )} error={error} />
        }
        if(item.field_type === "yes/no"){
            return  <YESORNO key={item.id} label={field_name} name={name} register={register} error={error} required={field_required}/>
        }
        if(item.field_type === "textarea"){
            return  <TextAreaInput key={item.id} label={item.field_name} required={field_required} {...register(name ,{...(field_required) && {validate:(v)=>Boolean(v && v.replace(/(?:^\s+|\s+$)/g ,'')) ||"Required"} } )} error={error}/>
        }
        if(item.field_type === "date"){
            return  <DateInput key={item.id} required={field_required}  label={field_name} name={name} handleOnDateChange={handleOnDateChange} value={watch(name)} error={error}/>
        }
        if(item.field_type === "number"){
            return  <NumberInput key={item.id} required={field_required} label={field_name} placeholder={field_name} {...register(name ,{...(field_required) && {validate:(v)=>Boolean(v) ||"Required"} } )} error={error} />
        }
        if(item.field_type === "upload"){
            return <UploadInput id={item.id} key={item.id} required={field_required} label={field_name} handleOnFilesDelete={(e)=>handleOnFilesDelete(e,name)} handleOnChangeFiles={(e)=>handleOnChangeFiles(e,name)} placeholder={field_name} file_list={watch(name)} {...register(name  )} error={error} toggleImageViewer={toggleImageViewer} />
        }
        return <TextInput key={item.id} label={field_name} placeholder={field_name} required={field_required} {...register(name ,{...(field_required) && {validate:(v)=>Boolean(v && v.replace(/(?:^\s+|\s+$)/g ,'')) ||"Required"} } )}  error={error}/>
    })
}






/**
 * 
 * @param {React.HTMLAttributes} props 
 * @returns 
 */
export const NextButton = (props={}) => {
    return <div className="position-relative col-12 col-md-12 d-flex" >
        <button style={{ cursor: "pointer" }} {...props} >Next</button>
    </div>

}